import { useEffect } from 'react';

export const useSetGlobalDataSeller = (sellerId?: string): void => {
  useEffect(() => {
    if (sellerId) {
      document.documentElement.setAttribute('data-seller', sellerId);
    } else {
      document.documentElement.removeAttribute('data-seller');
    }
  }, [sellerId]);
};
